import { render, staticRenderFns } from "./stuBest.vue?vue&type=template&id=0b40285d&scoped=true&"
import script from "./stuBest.vue?vue&type=script&lang=js&"
export * from "./stuBest.vue?vue&type=script&lang=js&"
import style0 from "./stuBest.vue?vue&type=style&index=0&id=0b40285d&prod&lang=less&"
import style1 from "./stuBest.vue?vue&type=style&index=1&id=0b40285d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40285d",
  null
  
)

export default component.exports